import { ref } from 'vue'

const darkMode = ref(localStorage.getItem('theme') !== 'light')

// Off-canvas navigation state. Only meaningful below the md breakpoint, where the
// sidebar is a drawer; at md+ the sidebar is always visible and this is ignored.
const sidebarOpen = ref(false)

const applyTheme = () => {
    document.documentElement.classList.toggle('dark', darkMode.value)
}

applyTheme()

export const useLayout = () => {
    const toggleDarkMode = () => {
        darkMode.value = !darkMode.value
        localStorage.setItem('theme', darkMode.value ? 'dark' : 'light')
        applyTheme()
    }

    const openSidebar   = () => { sidebarOpen.value = true }
    const closeSidebar  = () => { sidebarOpen.value = false }
    const toggleSidebar = () => { sidebarOpen.value = !sidebarOpen.value }

    return { darkMode, toggleDarkMode, sidebarOpen, openSidebar, closeSidebar, toggleSidebar }
}
